import { useQuery } from 'react-query';
import { PayloadAlumnoType, UserType } from '../types/types';
import hash from 'object-hash';
import dayjs from 'dayjs';
import { dateFormat } from '../components/Alumnos/AlumnosDetail';

const baseRoute = process.env.REACT_APP_BASE_URL;

export type PostAlumnoParams = { alumno?: PayloadAlumnoType };

async function alumnoApiCall(params?: PostAlumnoParams, user?: UserType | null) {
  if (!user?.token) return null;
  if (!params?.alumno) return null;

  // format dates
  if (!params.alumno.fechains) params.alumno.fechains = new Date().toISOString();
  let fechains = '';
  let fechanac = '';
  if (params?.alumno?.fechanac
    && params.alumno.fechanac.length > 10
    && dayjs(params?.alumno?.fechanac).isValid()) fechanac = dayjs(params?.alumno?.fechanac).toISOString();
  else if (dayjs(params?.alumno?.fechanac, dateFormat).isValid()) fechanac = dayjs(params?.alumno?.fechanac, dateFormat).toISOString();

  if (params?.alumno?.fechains
    && params.alumno.fechains.length > 10
    && dayjs(params?.alumno?.fechains).isValid()) fechains = dayjs(params?.alumno?.fechains).toISOString();
  else if (dayjs(params?.alumno?.fechains, dateFormat).isValid()) fechains = dayjs(params?.alumno?.fechains, dateFormat).toISOString();

  params.alumno.fechains = fechains;
  params.alumno.fechanac = fechanac;

  params.alumno.apellido = params.alumno.apellido?.trim();
  params.alumno.name = params.alumno.name?.trim();

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${user.token}`,

  };
  const response = await fetch(
    `${baseRoute}/api/alumnos`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as UserType;
}

export function usePostAlumno(params?:PostAlumnoParams, user?: UserType | null) {
  return useQuery<UserType | null, Error>(
    ['postAlumnoApi', hash(params || ''), hash(user ?? '')],
    () => alumnoApiCall(params, user), {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: false,
      retry: false,
    },
  );
}

export function useAutoPostAlumno(params?:PostAlumnoParams, user?: UserType | null) {
  return useQuery<UserType | null, Error>(
    ['useAutoPostAlumno', hash(params || ''), hash(user ?? '')],
    () => alumnoApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}
